import { forwardRef, useEffect, useImperativeHandle, useState } from "react";

const MentionList = forwardRef(({ items, command, label, editor, range }, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => setSelectedIndex(0), [items]);

  useImperativeHandle(ref, () => ({
    onKeyDown({ event }) {
      if (event.key === "ArrowUp") {
        setSelectedIndex((i) => (i - 1 + items.length) % items.length);
        return true;
      }
      if (event.key === "ArrowDown") {
        setSelectedIndex((i) => (i + 1) % items.length);
        return true;
      }
      if (event.key === "Enter") {
        if (items[selectedIndex]) selectItem(items[selectedIndex]);
        return true;
      }
      return false;
    },
  }));

  const selectItem = (item) => {
    if (item.key && !item.id) {
      editor.chain().focus().deleteRange(range).insertContent(`/${item.key}`).run();
      return;
    }

    if (!item.id) return;

    if (item.commandKey) {
      item["data-command"] = item.commandKey;
    }

    command(item);
  };

  if (!items.length) {
    return (
      <div className="mention-list">
        <div className="mention-empty">{label || "No users found"}</div>
      </div>
    );
  }

  return (
    <div className="mention-list">
      {items.map((item, i) => (
        <button
          key={item.id || item.label}
          className={`mention-item${i === selectedIndex ? " is-selected" : ""}`}
          onMouseDown={(e) => {
            e.preventDefault();
            selectItem(item);
          }}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
});

MentionList.displayName = "MentionList";

export default MentionList;
